import './mobmenu.scss';

// MOBILE MENU
//==================================================================================================================
function opeMenu() {
  // var menuBtn = document.getElementById('menu-toggle'),
  var menuBtn = $(".menu-toggle"),
      nav_box = document.getElementById('nav-box'),
      toggled = false;

  // menuBtn.addEventListener('click', function (e) {
  //   e.preventDefault();

  //   if (!toggled) {
  //     this.classList.add('toggled');
  //     toggled = true;
  //     nav_box.style.visibility = 'visible';
  //     // nav_box.style.right = 0;
  //     nav_box.classList.add('active');
  //   } else {
  //     this.classList.toggle('toggled');
  //     toggled = false;
  //     nav_box.style.visibility = 'hidden';
  //     // nav_box.style.right = "-100%";
  //     nav_box.classList.toggle('active');
  //   }

  //   if ($('#menu-toggle').hasClass('toggled')) {
  //     $('#eff_bl').fadeIn('1000');
  //     $('html').css('overflow-y', 'hidden');
  //   } else {
  //     $('#eff_bl').fadeOut('1000');
  //     $('html').css('overflow-y', 'scroll');
  //   }

  // }, false);
  menuBtn.on('click', function () {

    if (!toggled) {
      this.classList.add('toggled');
      toggled = true;
      // nav_box.style.visibility = 'visible';
      nav_box.classList.add('active');
    } else {
      this.classList.toggle('toggled');
      toggled = false;
      // nav_box.style.visibility = 'hidden';
      nav_box.classList.toggle('active');
    }

    if ($('#menu-toggle').hasClass('toggled')) {
      $('html').css('overflow-y', 'hidden');
    } else {
      $('html').css('overflow-y', 'scroll');
    }
  });
}
opeMenu();



// WEBPACK FOOTER //
// ./resources/views/partials/index/mob_menu/mobmenu.js